"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROICalculatorPanelContents = void 0;
var react_1 = __importDefault(require("react"));
var ROICalculatorPanelContents = function (_a) {
    var title = _a.title, description = _a.description, inputs = _a.inputs, widgetId = _a.widgetId;
    return (react_1.default.createElement("div", { className: "roi-calculator-panel-contents", id: "roi-calculator-panel-".concat(widgetId), role: "group", "aria-labelledby": "roi-calculator-panel__title-".concat(widgetId) },
        react_1.default.createElement("div", { className: "roi-calculator-panel-contents__scrim" }),
        react_1.default.createElement("div", { className: "roi-calculator-panel-contents__header user-font" },
            react_1.default.createElement("div", { className: "roi-calculator-panel-contents__title", id: "roi-calculator-panel__title-".concat(widgetId) }, title),
            react_1.default.createElement("div", { className: "roi-calculator-panel-contents__description" }, description)),
        react_1.default.createElement("div", { className: "roi-calculator-panel-contents__inputs qwilr-font" }, inputs)));
};
exports.ROICalculatorPanelContents = ROICalculatorPanelContents;
